import React from 'react';
import { useParams } from 'react-router-dom';

const Redirect = () => {
  const { urlRedirect } = useParams();
  const URI = decodeURIComponent(urlRedirect);

  const handleAction = () => {
    window.location.assign(URI);
  };

  return (
    <div>
      <p style={{fontSize:'20px', fontWeight:'bold', marginBottom: '40px', marginTop: '48px', lineHeight: '1.2'}}>ESTAMOS PROCESANDO TU SOLICITUD. HAZ CLIC EN CONTINUAR.</p>
      <button className="btn-redirect" onClick={handleAction}>CONTINUAR</button>
    </div>
  );
};

export default Redirect;
